
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as newsj8ZrEuGFE10Tr289fqF8K76ybeXReL_FfgoB33upewAMeta } from "/app/app/pages/news.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta } from "/app/app/pages/login.vue?macro=true";
import { default as contact9YIjszO30YiI1EF3Yrjj3j04hZuaoJnKFtoCHkd82XkMeta } from "/app/app/pages/contact.vue?macro=true";
import { default as invoicePBfDuLSk0sRwVSlpG8_erpKN4vP6F3yz37k4yhpUtUgMeta } from "/app/app/pages/invoice.vue?macro=true";
import { default as paymentetDYgA5A004kHXO5qaIJymI96XVDW_sSjXkbuaBgZLIMeta } from "/app/app/pages/payment.vue?macro=true";
import { default as registerhPH0MU2Juf_wsbIztPgIOhf1JmD4z1RPu17er_DhMMAMeta } from "/app/app/pages/register.vue?macro=true";
import { default as schedule9qoliR3tyGDseXdOxHjuhEYk77zYnYiNk3g_H0gOVvcMeta } from "/app/app/pages/schedule.vue?macro=true";
import { default as indexuxjJr1WDfCYJmgGGjVaYIilEBgz9DljbNdH0XfOhjqMMeta } from "/app/app/pages/bill/index.vue?macro=true";
import { default as verify_45otpczVH0NZ8ybwUfZRsw4OpSr1HW3sn2Op1flRc_2G5rxwMeta } from "/app/app/pages/verify-otp.vue?macro=true";
import { default as indexC4UJei9ju_9NtiRWoeKwfPQ4a2EMqvvdNKzN4W_OKkkMeta } from "/app/app/pages/booking/index.vue?macro=true";
import { default as ticketB_XiDupv4DMVkPf6ExYATKODF_AkWgZoGAPTjFNag_wMeta } from "/app/app/pages/lookup/ticket.vue?macro=true";
import { default as _91key_93hnSLa9_wP1Yi8960BnY4nYTmLL163xoqYyvDoOmXflgMeta } from "/app/app/pages/profile/[key].vue?macro=true";
import { default as cargordh14k9OssZVDaLq4__h_iYfvIzPJNqauKmR_R3Fg3IMeta } from "/app/app/pages/service/cargo.vue?macro=true";
import { default as ticket_45detailoU0KeQ2px_Zvkmv41V66AVfauEaxbxpLHHLUAJqWnzwMeta } from "/app/app/pages/ticket-detail.vue?macro=true";
import { default as redirect_45login9kUnXYH7SnvSyjKhA_PI5XXDgccXNs3_3Caoe6K5_ZcMeta } from "/app/app/pages/redirect-login.vue?macro=true";
import { default as ticketU4y2vXa2wQiFkj_69BveD7ytIHqeWGPF4q9wNYAQ7pAMeta } from "/app/app/pages/service/ticket.vue?macro=true";
import { default as verify_45accountXv2n9efNvNBaIKKZCSMkwOCMpkTvB75Qcg_Z_Cx6zPMMeta } from "/app/app/pages/verify-account.vue?macro=true";
import { default as booking_45sessiondUTPDjE4OoElzlh4AjL5vvQY57YaU9aNkVQGY4FESskMeta } from "/app/app/pages/booking-session.vue?macro=true";
import { default as change_45passwordCwPVSBzOvwwjBtlL1dAfJojvubq3kIPoiYw5Dzhw6igMeta } from "/app/app/pages/change-password.vue?macro=true";
import { default as forgot_45password_svvr_HXOSYgUMkqXVPpKJfwi_QEp8hjfRcKoAib3NwMeta } from "/app/app/pages/forgot-password.vue?macro=true";
import { default as _91id_93SR58E5yjNTCY6J8JopNz6NxiPubzr_qZYUQdyf7FJCQMeta } from "/app/app/pages/lookup/trip/[id].vue?macro=true";
import { default as indexfKy9oFHgHYKmV9Fk7pDl_1WNAauPPJDalc0bQSTraJUMeta } from "/app/app/pages/lookup/trip/index.vue?macro=true";
export default [
  {
    name: "news___vi",
    path: "/news",
    meta: newsj8ZrEuGFE10Tr289fqF8K76ybeXReL_FfgoB33upewAMeta || {},
    component: () => import("/app/app/pages/news.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    meta: newsj8ZrEuGFE10Tr289fqF8K76ybeXReL_FfgoB33upewAMeta || {},
    component: () => import("/app/app/pages/news.vue")
  },
  {
    name: "index___vi",
    path: "/",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "login___vi",
    path: "/login",
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "contact___vi",
    path: "/contact",
    meta: contact9YIjszO30YiI1EF3Yrjj3j04hZuaoJnKFtoCHkd82XkMeta || {},
    component: () => import("/app/app/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    meta: contact9YIjszO30YiI1EF3Yrjj3j04hZuaoJnKFtoCHkd82XkMeta || {},
    component: () => import("/app/app/pages/contact.vue")
  },
  {
    name: "invoice___vi",
    path: "/invoice",
    meta: invoicePBfDuLSk0sRwVSlpG8_erpKN4vP6F3yz37k4yhpUtUgMeta || {},
    component: () => import("/app/app/pages/invoice.vue")
  },
  {
    name: "invoice___en",
    path: "/en/invoice",
    meta: invoicePBfDuLSk0sRwVSlpG8_erpKN4vP6F3yz37k4yhpUtUgMeta || {},
    component: () => import("/app/app/pages/invoice.vue")
  },
  {
    name: "payment___vi",
    path: "/payment",
    meta: paymentetDYgA5A004kHXO5qaIJymI96XVDW_sSjXkbuaBgZLIMeta || {},
    component: () => import("/app/app/pages/payment.vue")
  },
  {
    name: "payment___en",
    path: "/en/payment",
    meta: paymentetDYgA5A004kHXO5qaIJymI96XVDW_sSjXkbuaBgZLIMeta || {},
    component: () => import("/app/app/pages/payment.vue")
  },
  {
    name: "register___vi",
    path: "/register",
    component: () => import("/app/app/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    component: () => import("/app/app/pages/register.vue")
  },
  {
    name: "schedule___vi",
    path: "/schedule",
    meta: schedule9qoliR3tyGDseXdOxHjuhEYk77zYnYiNk3g_H0gOVvcMeta || {},
    component: () => import("/app/app/pages/schedule.vue")
  },
  {
    name: "schedule___en",
    path: "/en/schedule",
    meta: schedule9qoliR3tyGDseXdOxHjuhEYk77zYnYiNk3g_H0gOVvcMeta || {},
    component: () => import("/app/app/pages/schedule.vue")
  },
  {
    name: "bill___vi",
    path: "/bill",
    meta: indexuxjJr1WDfCYJmgGGjVaYIilEBgz9DljbNdH0XfOhjqMMeta || {},
    component: () => import("/app/app/pages/bill/index.vue")
  },
  {
    name: "bill___en",
    path: "/en/bill",
    meta: indexuxjJr1WDfCYJmgGGjVaYIilEBgz9DljbNdH0XfOhjqMMeta || {},
    component: () => import("/app/app/pages/bill/index.vue")
  },
  {
    name: "verify-otp___vi",
    path: "/verify-otp",
    meta: verify_45otpczVH0NZ8ybwUfZRsw4OpSr1HW3sn2Op1flRc_2G5rxwMeta || {},
    component: () => import("/app/app/pages/verify-otp.vue")
  },
  {
    name: "verify-otp___en",
    path: "/en/verify-otp",
    meta: verify_45otpczVH0NZ8ybwUfZRsw4OpSr1HW3sn2Op1flRc_2G5rxwMeta || {},
    component: () => import("/app/app/pages/verify-otp.vue")
  },
  {
    name: "booking___vi",
    path: "/booking",
    meta: indexC4UJei9ju_9NtiRWoeKwfPQ4a2EMqvvdNKzN4W_OKkkMeta || {},
    component: () => import("/app/app/pages/booking/index.vue")
  },
  {
    name: "booking___en",
    path: "/en/booking",
    meta: indexC4UJei9ju_9NtiRWoeKwfPQ4a2EMqvvdNKzN4W_OKkkMeta || {},
    component: () => import("/app/app/pages/booking/index.vue")
  },
  {
    name: "lookup-ticket___vi",
    path: "/lookup/ticket",
    meta: ticketB_XiDupv4DMVkPf6ExYATKODF_AkWgZoGAPTjFNag_wMeta || {},
    component: () => import("/app/app/pages/lookup/ticket.vue")
  },
  {
    name: "lookup-ticket___en",
    path: "/en/lookup/ticket",
    meta: ticketB_XiDupv4DMVkPf6ExYATKODF_AkWgZoGAPTjFNag_wMeta || {},
    component: () => import("/app/app/pages/lookup/ticket.vue")
  },
  {
    name: "profile-key___vi",
    path: "/profile/:key()",
    meta: _91key_93hnSLa9_wP1Yi8960BnY4nYTmLL163xoqYyvDoOmXflgMeta || {},
    component: () => import("/app/app/pages/profile/[key].vue")
  },
  {
    name: "profile-key___en",
    path: "/en/profile/:key()",
    meta: _91key_93hnSLa9_wP1Yi8960BnY4nYTmLL163xoqYyvDoOmXflgMeta || {},
    component: () => import("/app/app/pages/profile/[key].vue")
  },
  {
    name: "service-cargo___vi",
    path: "/service/cargo",
    meta: cargordh14k9OssZVDaLq4__h_iYfvIzPJNqauKmR_R3Fg3IMeta || {},
    component: () => import("/app/app/pages/service/cargo.vue")
  },
  {
    name: "service-cargo___en",
    path: "/en/service/cargo",
    meta: cargordh14k9OssZVDaLq4__h_iYfvIzPJNqauKmR_R3Fg3IMeta || {},
    component: () => import("/app/app/pages/service/cargo.vue")
  },
  {
    name: "ticket-detail___vi",
    path: "/ticket-detail",
    meta: ticket_45detailoU0KeQ2px_Zvkmv41V66AVfauEaxbxpLHHLUAJqWnzwMeta || {},
    component: () => import("/app/app/pages/ticket-detail.vue")
  },
  {
    name: "ticket-detail___en",
    path: "/en/ticket-detail",
    meta: ticket_45detailoU0KeQ2px_Zvkmv41V66AVfauEaxbxpLHHLUAJqWnzwMeta || {},
    component: () => import("/app/app/pages/ticket-detail.vue")
  },
  {
    name: "redirect-login___vi",
    path: "/redirect-login",
    component: () => import("/app/app/pages/redirect-login.vue")
  },
  {
    name: "redirect-login___en",
    path: "/en/redirect-login",
    component: () => import("/app/app/pages/redirect-login.vue")
  },
  {
    name: "service-ticket___vi",
    path: "/service/ticket",
    meta: ticketU4y2vXa2wQiFkj_69BveD7ytIHqeWGPF4q9wNYAQ7pAMeta || {},
    component: () => import("/app/app/pages/service/ticket.vue")
  },
  {
    name: "service-ticket___en",
    path: "/en/service/ticket",
    meta: ticketU4y2vXa2wQiFkj_69BveD7ytIHqeWGPF4q9wNYAQ7pAMeta || {},
    component: () => import("/app/app/pages/service/ticket.vue")
  },
  {
    name: "verify-account___vi",
    path: "/verify-account",
    component: () => import("/app/app/pages/verify-account.vue")
  },
  {
    name: "verify-account___en",
    path: "/en/verify-account",
    component: () => import("/app/app/pages/verify-account.vue")
  },
  {
    name: "booking-session___vi",
    path: "/booking-session",
    meta: booking_45sessiondUTPDjE4OoElzlh4AjL5vvQY57YaU9aNkVQGY4FESskMeta || {},
    component: () => import("/app/app/pages/booking-session.vue")
  },
  {
    name: "booking-session___en",
    path: "/en/booking-session",
    meta: booking_45sessiondUTPDjE4OoElzlh4AjL5vvQY57YaU9aNkVQGY4FESskMeta || {},
    component: () => import("/app/app/pages/booking-session.vue")
  },
  {
    name: "change-password___vi",
    path: "/change-password",
    meta: change_45passwordCwPVSBzOvwwjBtlL1dAfJojvubq3kIPoiYw5Dzhw6igMeta || {},
    component: () => import("/app/app/pages/change-password.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordCwPVSBzOvwwjBtlL1dAfJojvubq3kIPoiYw5Dzhw6igMeta || {},
    component: () => import("/app/app/pages/change-password.vue")
  },
  {
    name: "forgot-password___vi",
    path: "/forgot-password",
    component: () => import("/app/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    component: () => import("/app/app/pages/forgot-password.vue")
  },
  {
    name: "lookup-trip-id___vi",
    path: "/lookup/trip/:id()",
    meta: _91id_93SR58E5yjNTCY6J8JopNz6NxiPubzr_qZYUQdyf7FJCQMeta || {},
    component: () => import("/app/app/pages/lookup/trip/[id].vue")
  },
  {
    name: "lookup-trip-id___en",
    path: "/en/lookup/trip/:id()",
    meta: _91id_93SR58E5yjNTCY6J8JopNz6NxiPubzr_qZYUQdyf7FJCQMeta || {},
    component: () => import("/app/app/pages/lookup/trip/[id].vue")
  },
  {
    name: "lookup-trip___vi",
    path: "/lookup/trip",
    meta: indexfKy9oFHgHYKmV9Fk7pDl_1WNAauPPJDalc0bQSTraJUMeta || {},
    component: () => import("/app/app/pages/lookup/trip/index.vue")
  },
  {
    name: "lookup-trip___en",
    path: "/en/lookup/trip",
    meta: indexfKy9oFHgHYKmV9Fk7pDl_1WNAauPPJDalc0bQSTraJUMeta || {},
    component: () => import("/app/app/pages/lookup/trip/index.vue")
  },
  {
    name: "google login___vi",
    path: "/callback/google",
    component: () => import("/app/app/pages/redirect-login.vue")
  },
  {
    name: "google login___en",
    path: "/en/callback/google",
    component: () => import("/app/app/pages/redirect-login.vue")
  },
  {
    name: "facebook login___vi",
    path: "/callback/facebook",
    component: () => import("/app/app/pages/redirect-login.vue")
  },
  {
    name: "facebook login___en",
    path: "/en/callback/facebook",
    component: () => import("/app/app/pages/redirect-login.vue")
  },
  {
    name: "github login___vi",
    path: "/callback/github",
    component: () => import("/app/app/pages/redirect-login.vue")
  },
  {
    name: "github login___en",
    path: "/en/callback/github",
    component: () => import("/app/app/pages/redirect-login.vue")
  }
]